var map = {
	"./1.svg": 73205,
	"./2.svg": 85685,
	"./3.svg": 78383,
	"./4.svg": 15888,
	"./5.png": 92389,
	"./6.png": 86696,
	"./7.png": 51617,
	"./8.png": 12441
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79240;